import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const deutscheBahn = defineConnector({
  identifier: "deutscheBahn",
  name: "Deutsche Bahn",
  tagLine: "German rail timetables, stations, and realtime changes",
  keywords: "db api marketplace timetables stada ris fahrplan bahnhof zug",
  logo,
  protocol: "http",
  tags: ["data", "travel"],
  defaultUrlPattern: () => domainToRegex("apis.deutschebahn.com"),
  auth: (app) =>
    headerAuth([
      { name: "DB-Client-Id", value: app.config.clientId },
      { name: "DB-Api-Key", value: app.secret.apiKey },
    ]),
  steps: [
    {
      title: "Register an application",
      items: [
        {
          kind: "markdown",
          content:
            "Sign up at the [**DB API Marketplace**](https://developers.deutschebahn.com/db-api-marketplace/apis/), create an application, and subscribe it to the APIs you need — **Timetables** for schedules and realtime changes, **StaDa** or **RIS::Stations** for station data. The application page shows its client ID and API key.",
        },
      ],
    },
    {
      title: "Enter your application credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "configuration", field: "clientId" },
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          helperText:
            "Shown as the application’s client secret. The free plan allows 60 calls a minute with no availability guarantee.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://apis.deutschebahn.com/db-api-marketplace/apis/timetables/v1/station/BLS",
      expectedStatus: [200, 403],
    }),
  },
});
